import React, { useEffect, useState } from "react";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Drawer,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Tag,
  Typography,
} from "antd";
import { ReactComponent as LeftArrowIcon } from "../../../../../assets/icons/chevron-left.svg";
// import { ReactComponent as MobCreditWhiteIcon } from "../../../../assets/icons/mobCreditWhiteIcon.svg";

import {
  useAddNewAddressMutation,
  useUpdateAddressMutation,
} from "../../../../../apis/Seller/SellerStoreSalesAPI";
import { useDispatch, useSelector } from "react-redux";
import {
  billingAddressSelector,
  createQuoteUserSelector,
  editQuoteDataSelector,
  // deliveryAddressSelector,
} from "../../../../../redux/slices/createQuote/selector";
import {
  getBillingAddress,
  getDeliveryAddress,
  updateAddressFlag,
} from "../../../../../redux/slices/createQuote/action";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../../NotificationToast/NotificationToast";
import { Option } from "antd/es/mentions";
import { gstRegex, stateOptions } from "../../../../../commonUtils/commonUtils";
import { useParams } from "react-router-dom";
import UserBillingConfirmModal from "../../UserBillingConfirmModal/UserBillingConfirmModal";
//import {isDisabledBillingAddress} from "../../../../commonFuntions/CommonUtilFunctions";
import { getCreateOrderUserData } from "../../../../../redux/slices/createOrder/action";
import "./AddressForm.css";

const GOOGLE_MAPS_LIBRARIES = ["places"];

const DeliveryAddress = ({
  deliveryModal,
  setDeliveryModal,
  setIsModalOpen,
  editData,
  initialFormData,
  formData,
  setFormData,
  addressListModal,
  addressList,
  addCustName,
  addCustMobileNo,
  addCustEmail,
  addCustGSTIN,
  getEditOrderAddressAPI,
  selectedMapAddress,
  setShowGoogleMapsModal,
  setPendingAddressType,
}) => {
  

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyCVLamNquALGHbWCgb-U3-Ab8OdSyhOkEM",
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  const [previewMap, setPreviewMap] = useState(null);
  const [editLocation, setEditLocation] = useState(null);
  const dispatch = useDispatch();
  // const deliveryAddressRedux = useSelector(deliveryAddressSelector);
  const billingAddressRedux = useSelector(billingAddressSelector);

  const { Text, Title } = Typography;
  const params_id = useParams();

  const mob_user = useSelector(createQuoteUserSelector);
  const mob_user_2 = useSelector(editQuoteDataSelector);

  const [validationErrors, setValidationErrors] = useState({
    mobileNo: "",
    email: "",
    pincode: "",
    // Add more fields if needed
  });
  const [isFormValid, setIsFormValid] = useState(false);
  const [openBillingModal, setOpenBillingModal] = useState(false);
  const getIsMobileView = () =>
    typeof window !== "undefined" ? window.innerWidth <= 768 : false;
  const [isMobileView, setIsMobileView] = useState(getIsMobileView);
  // eslint-disable-next-line
  const [address_tag, setAddress_tag] = useState("");

  const handleCancelBillingModal = () => {
    setOpenBillingModal(false);
  };
  const handleSaveBillingModal = () => {
    setFormData((prevData) => ({
      ...prevData,
      address_type: "",
    }));
    setOpenBillingModal(false);
  };
  const handleAddressTag = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      [event.target.name]: event.target.value,
    }));
    setAddress_tag(event.target.value);
  };
  useEffect(() => {
    if (editData) {
      setFormData({
        nameCompany: editData?.name || "",
        mobileNo: editData?.phone_number || "",
        gst: editData?.gst_number || "",
        addressI: editData?.address_line_1 || "",
        addressII: editData?.address_line_2 || "",
        google_map_link: editData?.address_line_2 || "",
        pincode: editData?.pincode || "",
        city: editData?.city || "",
        state: editData?.state || "",
        email: editData?.email || "",
        address_tag: editData?.address_tag || "",
        site_person: editData?.site_person || "",
        site_person_mobile: editData?.site_person_mobile || "",
        address_type: editData.address_type || "",
      });

      // Get location from editData
      if (editData.latitude && editData.longitude) {
        setEditLocation({
          lat: parseFloat(editData.latitude),
          lng: parseFloat(editData.longitude),
        });
      } else if (isLoaded && window.google) {
        // Geocode address to get lat/lng
        const geocoder = new window.google.maps.Geocoder();
        const address = `${editData?.address_line_1 || ""} ${editData?.address_line_2 || ""} ${editData?.city || ""} ${editData?.state || ""} ${editData?.pincode || ""}`;
        
        geocoder.geocode({ address }, (results, status) => {
          if (status === "OK" && results[0]) {
            setEditLocation({
              lat: results[0].geometry.location.lat(),
              lng: results[0].geometry.location.lng(),
            });
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editData, isLoaded]);
  const validateForm = () => {
    const requiredFields = [
      "nameCompany",
      "mobileNo",
      "addressI",
      // "email",
      "city",
      "state",
      "pincode",
    ];

    const isValid = requiredFields.every((field) => !!formData[field]);
    // setIsFormValid(isValid && noValidationErrors);
    setIsFormValid(isValid);
  };
  const [
    createNewAddressApi,
    { isSuccess: createAddressSuccess, isLoading: isCreateLoading },
  ] = useAddNewAddressMutation();
  const [
    updateAddressApi,
    { isSuccess: updateAddressSuccess, isLoading: isUpdateLoading },
  ] = useUpdateAddressMutation();

  useEffect(() => {
    if (createAddressSuccess || updateAddressSuccess) {
      dispatch(updateAddressFlag(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createAddressSuccess, updateAddressSuccess]);

  const handleSaveAddress = async () => {
    const newValidationErrors = {};

    // Validate mobile number (10 digits)
    if (!/^[0-9]{10}$/.test(formData.mobileNo)) {
      newValidationErrors.mobileNo = "Invalid mobile number (10 digits)";
    }

    //Validate GST
    // if (!/^(?:[0-3|9][0-9])[a-zA-Z0-9]{13}$/.test(formData.gst)) {
    //   newValidationErrors.gst = "Invalid GST";
    // }
    // Validate email
    // if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    //   newValidationErrors.email = "Invalid email";
    // }

    // Validate pincode (6 digits)
    if (!/^[0-9]{6}$/.test(formData.pincode)) {
      newValidationErrors.pincode = "Invalid pincode (6 digits)";
    }
    if (formData.gst.trim() !== "") {
      if (!gstRegex.test(formData.gst)) {
        newValidationErrors.gst = "Invalid GSTIN";
      }
    }

    setValidationErrors(newValidationErrors);

    if (Object.values(newValidationErrors).some((error) => !!error)) {
      // If there are validation errors, stop the function
      return;
    }

    // setFormData(initialFormData);
    const params = {
      mob_user: params_id?.quote_id
        ? mob_user_2?.rfq_order?.rfq_created_by?.id || mob_user_2?.user?.id
        : mob_user?.id ||
          mob_user?.payload?.user_details?.id ||
          mob_user?.payload?.id,

      name: addCustName,
      phone_number: addCustMobileNo,
      email: addCustEmail,
      gst_number: addCustGSTIN,
      address: {
        name: formData.nameCompany,
        phone_number: formData.mobileNo,
        address_line_1: formData.addressI,
        address_line_2: formData.addressII,
        city: formData.city,
        state: formData.state,
        pincode: formData.pincode,
        address_type: formData?.address_type,
        email: formData.email,
        gst_number: formData.gst,
        google_map_link: formData.addressII,
        site_person: formData.site_person,
        site_person_mobile: formData.site_person_mobile,
        address_tag: formData.address_tag,
        latitude: formData.lat,
        longitude: formData.lng,
      },
    };
    if (editData?.id) {
      const params = {
        name: formData.nameCompany,
        phone_number: formData.mobileNo,
        address_line_1: formData.addressI,
        address_line_2: formData.addressII,
        city: formData.city,
        state: formData.state,
        pincode: formData.pincode,
        address_type: formData?.address_type,
        email: formData.email,
        gst_number: formData.gst,
        google_map_link: formData.addressII,
        site_person: formData.site_person,
        site_person_mobile: formData.site_person_mobile,
        address_tag: formData.address_tag,
        address_id: editData.id,
        latitude: formData.lat,
        longitude: formData.lng,
      };

      const response = await updateAddressApi(params);
      if (response?.data?.status === true) {
        showSuccessToast(response.data.message);
        setDeliveryModal(false);
        dispatch(getDeliveryAddress(response?.data?.data));
        setFormData(initialFormData);

        // if (response?.data?.data.id === deliveryAddressRedux?.id) {
        // }
        if (response?.data?.data?.id === billingAddressRedux?.id) {
          dispatch(getBillingAddress(response?.data?.data));
        }
      } else {
        // if (response.error.data.data.email[0]) {
        //   showErrorToast(response.error.data.data.email[0]);
        // }
        showErrorToast(response?.data?.message);
      }
    } else {
      const response = await createNewAddressApi(params);
      // console.log("🚀 ~ handleSaveAddress ~ response:", response);

      if (response?.data?.status === true) {
        showSuccessToast(response?.data?.message);
        addressListModal();
        dispatch(getDeliveryAddress(response?.data?.data));
        setFormData(initialFormData);
        if (params?.mob_user === 0 || params?.mob_user === undefined) {
          const userData = {
            id: response?.data?.data?.id,
            name: response?.data?.data?.name,
            phoneNumber: response?.data?.data?.phone_number,
            mobVendor: response?.data?.data?.customer,
          };
          dispatch(getCreateOrderUserData(userData));
          //dispatch(getBillingAddress(response?.data?.data));
          //handleSetSelector(userData);
          getEditOrderAddressAPI({ phone_number: addCustMobileNo });
        } else {
          if (response?.data?.data?.id === billingAddressRedux?.id) {
            dispatch(getBillingAddress(response?.data?.data));
          }
        }

        setDeliveryModal(false);
      } else {
        // if (response?.error?.data?.data?.email[0]) {
        //   showErrorToast(response?.error?.data?.data?.email[0]);
        // }
        showErrorToast(response?.data?.message);
      }
    }
  };
  useEffect(() => {
    validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  useEffect(() => {
    const handleResize = () => setIsMobileView(getIsMobileView());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleInputChange = (field, value) => {
    // let validatedValue = value;

    // if (field === "mobileNo") {
    //   validatedValue = value.replace(/\D/g, "");
    // }
    if (
      field?.target?.name === "gst_number" &&
      field?.target?.value?.length > 15
    )
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [field]: "",
      }));

    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
    // validateForm();
  };

  const handleBack = () => {
    setFormData(initialFormData);
    setDeliveryModal(false);
    setIsModalOpen(true);
    setValidationErrors({ mobileNo: "", email: "", pincode: "" });
  };
  const handleCancel = () => {
    setFormData(initialFormData);
    setDeliveryModal(false);
    setValidationErrors({ mobileNo: "", email: "", pincode: "" });
  };
  const tagData = editData?.address_tag;
  // const isDisabledBillingAddressCheck = isDisabledBillingAddress(
  //   addressList || [],
  //   formData
  // );

  const handleChangeAddress = () => {
    setShowGoogleMapsModal(true);
    setPendingAddressType("Delivery");
  };

  const modalTitle = (
    <Row style={{ width: "100%", alignItems: "center" }}>
      <Col style={{ paddingTop: "6px", width: "35%" }}>
        <LeftArrowIcon style={{ cursor: "pointer" }} onClick={handleBack} />
      </Col>
      <Title level={4} style={{ width: "65%", margin: 0 }}>
        Delivery Address
      </Title>
    </Row>
  );

  const footerContent = (
    <Col
      className={isMobileView ? "delivery-address-mobile-footer" : ""}
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "28px",
        width: "100%",
      }}
    >
      <Button
        onClick={handleCancel}
        style={{
          height: "48px",
          fontWeight: 500,
          fontSize: "14px",
          maxWidth: "120px",
          width: "100%",
        }}
      >
        CANCEL
      </Button>
      <Button
        loading={isCreateLoading || isUpdateLoading}
        style={{
          height: "48px",
          fontWeight: 500,
          fontSize: "14px",
          border: "none",
          color: "white",
          backgroundColor: "#0354a3",
        }}
        onClick={handleSaveAddress}
        disabled={!isFormValid}
      >
        {editData?.name ? "SAVE & UPDATE ADDRESS" : "SAVE THIS ADDRESS"}
      </Button>
    </Col>
  );

  const formContent = (
    <Form
          name="delivery_address"
          labelCol={{
            span: 24,
          }}
          wrapperCol={{
            span: 24,
          }}
          style={{
            height: isMobileView ? "100%" : "360px",
            width: "100%",
            overflow: "auto",
          }}
          autoComplete="off"
        >
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "2px 18px 18px 18px",
              gap: 12,
            }}
          >
            {editData?.id && editLocation && (
              <div className="selected-map-section">
                <div className="map-preview-container" style={{ height: "250px", width: "100%", marginBottom: "12px", borderRadius: "8px", overflow: "hidden" }}>
                  {isLoaded && (
                    <GoogleMap
                      mapContainerStyle={{ width: "100%", height: "100%" }}
                      center={editLocation}
                      zoom={15}
                      options={{
                        disableDefaultUI: true,
                        zoomControl: false,
                        streetViewControl: false,
                        mapTypeControl: false,
                        fullscreenControl: false,
                        gestureHandling: "none",
                        draggable: false,
                        scrollwheel: false,
                        disableDoubleClickZoom: true,
                      }}
                      onLoad={(mapInstance) => {
                        if (mapInstance.customMarker) {
                          mapInstance.customMarker.setMap(null);
                        }

                        const customMarkerSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="38" height="56" viewBox="0 0 38 56" fill="none">
                  <path opacity="0.8" d="M18.5512 56.0038C24.5311 56.0038 29.3788 54.6143 29.3788 52.9003C29.3788 51.1863 24.5311 49.7969 18.5512 49.7969C12.5713 49.7969 7.72363 51.1863 7.72363 52.9003C7.72363 54.6143 12.5713 56.0038 18.5512 56.0038Z" fill="#00DE9D"/>
                  <path d="M18.5944 0C8.34168 0 0 8.34113 0 18.5932C0 26.9743 5.55225 34.2588 13.5705 36.4985L17.6935 52.2679C17.7999 52.6777 18.1713 52.9638 18.5944 52.9638C19.0176 52.9638 19.389 52.6777 19.4954 52.2679L23.6184 36.4985C31.6367 34.2588 37.1889 26.9743 37.1889 18.5932C37.1889 8.34113 28.8472 0 18.5944 0Z" fill="#1C1C1C"/>
                  <ellipse cx="18.6207" cy="18.483" rx="6.06897" ry="6.06898" fill="white"/>
                </svg>`;

                        const marker = new window.google.maps.Marker({
                          position: editLocation,
                          map: mapInstance,
                          title: "Selected Location",
                          icon: {
                            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(customMarkerSVG),
                            scaledSize: new window.google.maps.Size(18, 26),
                            anchor: new window.google.maps.Point(9, 26),
                            origin: new window.google.maps.Point(0, 0),
                          },
                          optimized: false,
                        });

                        mapInstance.customMarker = marker;
                      }}
                      onUnmount={() => {
                        if (previewMap && previewMap.customMarker) {
                          previewMap.customMarker.setMap(null);
                          previewMap.customMarker = null;
                        }
                      }}
                    />
                  )}
                </div>
              </div>
            )}
            {selectedMapAddress && !editData?.id && (
              <div className="selected-map-section">
                <div className="map-preview-container" style={{ height: "250px", width: "100%", marginBottom: "12px", borderRadius: "8px", overflow: "hidden" }}>
                  {isLoaded && (
                    <GoogleMap
                      mapContainerStyle={{ width: "100%", height: "100%" }}
                      center={{ lat: selectedMapAddress.lat, lng: selectedMapAddress.lng }}
                      zoom={15}
                      options={{
                        disableDefaultUI: true,
                        zoomControl: false,
                        streetViewControl: false,
                        mapTypeControl: false,
                        fullscreenControl: false,
                        gestureHandling: "none",
                        draggable: false,
                        scrollwheel: false,
                        disableDoubleClickZoom: true,
                      }}
                      onLoad={(mapInstance) => {
                        setPreviewMap(mapInstance);
                        if (mapInstance.customMarker) {
                          mapInstance.customMarker.setMap(null);
                        }

                        const customMarkerSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="38" height="56" viewBox="0 0 38 56" fill="none">
                  <path opacity="0.8" d="M18.5512 56.0038C24.5311 56.0038 29.3788 54.6143 29.3788 52.9003C29.3788 51.1863 24.5311 49.7969 18.5512 49.7969C12.5713 49.7969 7.72363 51.1863 7.72363 52.9003C7.72363 54.6143 12.5713 56.0038 18.5512 56.0038Z" fill="#00DE9D"/>
                  <path d="M18.5944 0C8.34168 0 0 8.34113 0 18.5932C0 26.9743 5.55225 34.2588 13.5705 36.4985L17.6935 52.2679C17.7999 52.6777 18.1713 52.9638 18.5944 52.9638C19.0176 52.9638 19.389 52.6777 19.4954 52.2679L23.6184 36.4985C31.6367 34.2588 37.1889 26.9743 37.1889 18.5932C37.1889 8.34113 28.8472 0 18.5944 0Z" fill="#1C1C1C"/>
                  <ellipse cx="18.6207" cy="18.483" rx="6.06897" ry="6.06898" fill="white"/>
                </svg>`;

                        const marker = new window.google.maps.Marker({
                          position: { lat: selectedMapAddress.lat, lng: selectedMapAddress.lng },
                          map: mapInstance,
                          title: "Selected Location",
                          icon: {
                            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(customMarkerSVG),
                            scaledSize: new window.google.maps.Size(18, 26),
                            anchor: new window.google.maps.Point(9, 26),
                            origin: new window.google.maps.Point(0, 0),
                          },
                          optimized: false,
                        });

                        mapInstance.customMarker = marker;
                      }}
                      onUnmount={() => {
                        if (previewMap && previewMap.customMarker) {
                          previewMap.customMarker.setMap(null);
                          previewMap.customMarker = null;
                        }
                      }}
                    />
                  )}
                </div>
                <div className="selected-address-info">
                  <div className="address-header">
                    <div className="address-icon-text">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="#22C55E"/>
                      </svg>
                      <Text className="location-name">Selected Location</Text>
                    </div>
                    <Button 
                      className="change-link-button"
                      onClick={handleChangeAddress}
                      type="link"
                    >
                      CHANGE
                    </Button>
                  </div>
                  <Text className="full-address-text">{selectedMapAddress.formatted_address || selectedMapAddress.address}</Text>
                </div>
              </div>
            )}
            <Form.Item
              label={
                <Col>
                  Name / Company<Text style={{ color: "#FF0000" }}> *</Text>
                </Col>
              }
              style={{ margin: 0 }}
            >
              <Input
                style={{ height: 45 }}
                name="nameCompany"
                value={formData.nameCompany}
                onChange={(e) =>
                  handleInputChange("nameCompany", e.target.value)
                }
              />
            </Form.Item>
            <Col style={{ display: "flex", gap: "1rem" }}>
              <Form.Item
                label={
                  <Col>
                    Business Mobile(for OTP)
                    <Text style={{ color: "#FF0000" }}> *</Text>
                  </Col>
                }
                style={{ margin: 0 }}
                help={
                  validationErrors.mobileNo && (
                    <Col style={{ color: "red" }}>
                      Invalid mobile number (10 digits)
                    </Col>
                  )
                }
              >
                <Input
                  style={{
                    height: 45,
                    borderColor: validationErrors.mobileNo ? "red" : "",
                    backgroundColor: validationErrors.mobileNo ? "#FFD6D6" : "",
                  }}
                  name="mobileNo"
                  maxLength={10}
                  // onKeyDown={(e) => {
                  //   if (
                  //     e.ctrlKey &&
                  //     e.key === "c" &&
                  //     e.ctrlKey &&
                  //     e.key === "v" &&
                  //     e.ctrlKey &&
                  //     e.key === "x" &&
                  //     (e.key < "0" || e.key > "9") &&
                  //     e.key !== "Backspace" &&
                  //     e.key !== "ArrowLeft" &&
                  //     e.key !== "ArrowRight" &&
                  //     e.key !== "Tab"
                  //   ) {
                  //     e.preventDefault();
                  //   }
                  // }}
                  value={formData.mobileNo}
                  onChange={(e) => {
                    if (/^\d{0,10}$/.test(e.target.value)) {
                      handleInputChange("mobileNo", e.target.value);
                    }
                  }}
                  // onChange={(e) =>
                  //   handleInputChange("mobileNo", e.target.value)
                  // }
                />
              </Form.Item>
              <Form.Item
                label="GSTIN (Optional)"
                // name="gst"
                style={{ margin: 0 }}
                // value={formData.gst}
                help={
                  validationErrors.gst && (
                    <Col
                      style={{
                        color: "red",
                      }}
                    >
                      Invalid Gst No
                    </Col>
                  )
                }
              >
                <Input
                  style={{
                    height: 45,
                    borderColor: validationErrors.gst ? "red" : "",
                    backgroundColor: validationErrors.gst ? "#FFD6D6" : "",
                  }}
                  value={formData.gst}
                  name="gst"
                  maxLength={15}
                  onChange={(e) => handleInputChange("gst", e.target.value)}
                />
              </Form.Item>
            </Col>
          </Col>
          <Divider style={{ margin: 0, borderTopWidth: "12px" }} />
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "10px 18px 18px 18px",
              gap: 12,
            }}
          >
            <Form.Item
              label={
                <Col>
                  House no/ Building name (Address line 1)
                  <Text style={{ color: "#FF0000" }}> *</Text>
                </Col>
              }
              style={{ margin: 0 }}
            >
              <Input
                value={formData.addressI}
                name="addressI"
                style={{ height: 45 }}
                onChange={(e) => handleInputChange("addressI", e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Road/ Area/ Colony or google maps link"
              style={{ margin: 0 }}
            >
              <Input
                style={{ height: 45 }}
                name="addressII"
                value={formData.addressII}
                onChange={(e) => handleInputChange("addressII", e.target.value)}
              />
            </Form.Item>
            <Col style={{ display: "flex", gap: "1rem" }}>
              <Form.Item
                label={
                  <Col>
                    Pincode
                    <Text style={{ color: "#FF0000" }}> *</Text>{" "}
                  </Col>
                }
                help={
                  validationErrors.pincode && (
                    <Col style={{ color: "red" }}>
                      Invalid pincode (6 digits)
                    </Col>
                  )
                }
                style={{ margin: 0 }}
              >
                <Input
                  style={{
                    height: 45,
                    borderColor: validationErrors.pincode ? "red" : "",
                    backgroundColor: validationErrors.pincode ? "#FFD6D6" : "",
                  }}
                  name="pincode"
                  maxLength={6}
                  // onKeyDown={(e) => {
                  //   if (
                  //     e.ctrlKey &&
                  //     e.key === "c" &&
                  //     e.ctrlKey &&
                  //     e.key === "v" &&
                  //     e.ctrlKey &&
                  //     e.key === "x" &&
                  //     (e.key < "0" || e.key > "9") &&
                  //     e.key !== "Backspace" &&
                  //     e.key !== "ArrowLeft" &&
                  //     e.key !== "ArrowRight" &&
                  //     e.key !== "Tab"
                  //   ) {
                  //     e.preventDefault();
                  //   }
                  // }}
                  value={formData.pincode}
                  // onChange={(e) => handleInputChange("pincode", e.target.value)}
                  onChange={(e) => {
                    if (/^\d{0,6}$/.test(e.target.value)) {
                      handleInputChange("pincode", e.target.value);
                    }
                  }}
                />
              </Form.Item>
              <Form.Item
                label={
                  <Col>
                    City <Text style={{ color: "#FF0000" }}> *</Text>{" "}
                  </Col>
                }
                style={{ margin: 0 }}
              >
                <Input
                  style={{ height: 45 }}
                  name="city"
                  value={formData.city}
                  onChange={(e) => handleInputChange("city", e.target.value)}
                />
              </Form.Item>
            </Col>
            <Form.Item
              label={
                <Col>
                  State <Text style={{ color: "#FF0000" }}> *</Text>{" "}
                </Col>
              }
              style={{ margin: 0 }}
            >
              {/* <Select
                placeholder="--Select state--"
                onChange={(e) => handleInputChange("state", e)}
                value={formData.state}
              >
                <Option disabled value="">
                  --Select state--
                </Option>
                <Option value="Karnataka">Karnataka</Option>
                <Option value="Tamil Nadu">Tamil Nadu</Option>
              </Select> */}
              <Select
                showSearch
                placeholder="--Select or Search  state--"
                onChange={(e) => handleInputChange("state", e)}
                value={formData.state}
                style={{
                  border: "1px solid #d9d9d9",
                  borderRadius: "6px",
                  height: "45px",
                }}
              >
                <Option disabled value="">
                  --Select or Search state--
                </Option>
                {stateOptions.map((option, index) => (
                  <Option key={index} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
              {/* <Input
                style={{ height: 45 }}
                name="state"
                value={formData.state}
                onChange={(e) => handleInputChange("state", e.target.value)}
              /> */}
            </Form.Item>
            <Form.Item
              label={
                <Col>
                  Email
                  {/* <Text style={{ color: "#FF0000" }}> *</Text> */}
                </Col>
              }
              help={
                validationErrors.email && (
                  <Col style={{ color: "red" }}>Invalid email</Col>
                )
              }
              style={{ margin: 0 }}
            >
              <Input
                value={formData.email}
                name="email"
                style={{
                  height: 45,
                  borderColor: validationErrors.email ? "red" : "",
                  backgroundColor: validationErrors.email ? "#FFD6D6" : "",
                }}
                onChange={(e) => handleInputChange("email", e.target.value)}
              />
            </Form.Item>
            <Col style={{ display: "flex", gap: "1rem" }}>
              <Form.Item
                label={<Col>Site person(for delivery)</Col>}
                style={{ margin: 0 }}
              >
                <Input
                  style={{ height: 45 }}
                  name="site_person"
                  value={formData?.site_person}
                  onChange={(e) =>
                    handleInputChange("site_person", e.target.value)
                  }
                />
              </Form.Item>
              <Form.Item
                label={<Col>Site person mobile</Col>}
                style={{ margin: 0 }}
                help={
                  validationErrors.site_person_mobile && (
                    <Col style={{ color: "red" }}>
                      Invalid mobile number (10 digits)
                    </Col>
                  )
                }
              >
                <Input
                  style={{
                    height: 45,
                    borderColor: validationErrors.site_person_mobile
                      ? "red"
                      : "",
                    backgroundColor: validationErrors.site_person_mobile
                      ? "#FFD6D6"
                      : "",
                  }}
                  name="site_person_mobile"
                  maxLength={10}
                  // onKeyDown={(e) => {
                  //   if (
                  //     e.ctrlKey &&
                  //     e.key === "c" &&
                  //     e.ctrlKey &&
                  //     e.key === "v" &&
                  //     e.ctrlKey &&
                  //     e.key === "x" &&
                  //     (e.key < "0" || e.key > "9") &&
                  //     e.key !== "Backspace" &&
                  //     e.key !== "ArrowLeft" &&
                  //     e.key !== "ArrowRight" &&
                  //     e.key !== "Tab"
                  //   ) {
                  //     e.preventDefault();
                  //   }
                  // }}
                  value={formData?.site_person_mobile}
                  onChange={(e) => {
                    if (/^\d{0,10}$/.test(e.target.value)) {
                      handleInputChange("site_person_mobile", e.target.value);
                    }
                  }}
                  // onChange={(e) =>
                  //   handleInputChange("mobileNo", e.target.value)
                  // }
                />
              </Form.Item>
            </Col>
            <Form.Item
              style={{ margin: 0 }}
              name="radioGroup"
              label="Select Tag"
              className="hidden"
              value={formData.address_tag}
              // onChange={(e) => handleInputChange("address_tag", e.target.value)}
              // rules={[{ required: true, message: "Please select an option" }]}
            >
              <Radio.Group
                defaultValue={tagData}
                // onChange={(e) => handleAddressTag(e)}
                onChange={(e) =>
                  handleInputChange("address_tag", e.target.value)
                }
                name={"address_tag"}
              >
                <Radio value={"Home"}>
                  <Tag
                    style={{
                      width: "60px",
                      height: "30px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    Home
                  </Tag>
                </Radio>
                <Radio value={"Office"}>
                  <Tag
                    style={{
                      width: "70px",
                      height: "30px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    Office
                  </Tag>
                </Radio>
                {/* <Radio
                  value={"Billing Address"}
                  disabled={!formData.gst}
                  checked={formData?.address_tag === "Billing Address"}
                >
                  <Tag
                    style={{
                      width: "140px",
                      height: "30px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    Billing Address
                  </Tag>
                </Radio> */}
                {/* <Radio value={"Mob_credit"} className="radio-mob-credit"                   checked={formData?.address_tag === "Mob_credit"}
>
                  <MobCreditWhiteIcon />
                  <Tag
                    style={{
                      width: "120px",
                      height: "30px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    MOB CREDIT
                  </Tag>
                </Radio> */}
              </Radio.Group>
            </Form.Item>

            <Checkbox
              value={"Billing"}
              // disabled={
              //   !gstRegex?.test(formData?.gst)
              //   // editData?.address_type === "Billing"
              //   //   ? false || !gstRegex?.test(formData?.gst)
              //   //   : isDisabledBillingAddressCheck ||
              //   //     !gstRegex?.test(formData?.gst)
              // }
              checked={formData?.address_type === "Billing"}
              onChange={(e) => handleAddressTag(e)}
              name={"address_type"}
            >
              <Text
                style={{
                  // width: "140px",
                  height: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "14px",
                  fontWeight: 500,
                }}
              >
                Mark as billing address
              </Text>
            </Checkbox>
            {/* {!gstRegex.test(formData?.gst) && (
              <Text
                style={{
                  display: "block",
                  // marginTop: "20px",
                  color: "#c13615",
                  fontSize: "14px",
                  fontWeight: "normal",
                }}
              >
                Please add GSTIN to include the ‘Billing Address’ tag
              </Text>
            )} */}
          </Col>
          <UserBillingConfirmModal
            open={openBillingModal}
            handleCancel={handleCancelBillingModal}
            handleSave={handleSaveBillingModal}
          />
        </Form>
  );

  return (
    <>
      {isMobileView ? (
        <Drawer
          title={modalTitle}
          className="delivery-address-mobile-drawer"
          wrapClassName="delivery-address-mobile-drawer-wrap"
          placement="bottom"
          height="90vh"
          open={deliveryModal}
          onClose={handleCancel}
          closable={false}
          bodyStyle={{ padding: 0 }}
          contentWrapperStyle={{
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
            borderBottomLeftRadius: "0px",
            borderBottomRightRadius: "0px",
            overflow: "hidden",
          }}
        >
          <div className="delivery-address-drawer-body">
            <div className="delivery-address-drawer-scroll">{formContent}</div>
            {footerContent}
          </div>
        </Drawer>
      ) : (
        <Modal
          title={modalTitle}
          open={deliveryModal}
          onCancel={handleCancel}
          closeIcon={false}
          footer={[footerContent]}
        >
          {formContent}
        </Modal>
      )}
    </>
  );
};

export default React.memo(DeliveryAddress);
